import {useShopperCustomersMutation} from '@salesforce/commerce-sdk-react'

const useMutateCustomerTpaData = () => {
    const updateCustomerMutation = useShopperCustomersMutation('updateCustomer')

    const mutateCustomerTpaTrackingData = (customerId, tpaTrackingCookie) => {
        try {
            const response = updateCustomerMutation.mutate({
                parameters: {customerId},
                body: {
                    c_tpaTracking: tpaTrackingCookie
                }
            })
            return response
        } catch (error) {
            console.error('Error updating customer c_tpaTracking data:', error)
            throw error
        }
    }

    const mutateCustomerTpaBrandingData = (customerId, tpaValue) => {
        try {
            const response = updateCustomerMutation.mutate({
                parameters: {customerId},
                body: {
                    c_TPA: tpaValue
                }
            })
            return response
        } catch (error) {
            console.error('Error updating customer c_TPA data:', error)
            throw error
        }
    }

    return {mutateCustomerTpaBrandingData, mutateCustomerTpaTrackingData}
}

export default useMutateCustomerTpaData
